/**
 * Created by satuk on 20.07.17.
 */
import React from "react";
import Layout from '../Layout';

const Page404 = () => {
  return (
  <Layout>
    <div>page ot found...</div>
  </Layout>
  );
};

export default Page404;



// WEBPACK FOOTER //
// ./src/components/Page404/index.js